export const apiConfig = {
  BASE_API: import.meta.env.VITE_API_URL ?? "https://staging.api.rebuild.work",
};
